import { useAssetDetailsContext } from "@/pages/asset-details/context/assetDetailsContext";
import { createStyles, Grid, makeStyles } from "@material-ui/core";
import type { EditableCallbackParams } from "ag-grid-enterprise";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

type Props = EditableCallbackParams;

const useStyles = makeStyles((theme) =>
	createStyles({
		input: {
			"&:focus::placeholder": {
				color: "transparent !important",
			},
		},
	}),
);

export const LOTONameColumn = ({ data }: Props) => {
	const classes = useStyles();
	const [searchParams] = useSearchParams();

	const {
		state: { LOTONameToLink },
		actions: { setLOTONameToLink },
	} = useAssetDetailsContext();

	const handleChangeLOTONameChange = (e: any) => {
		setLOTONameToLink(e.target.value.toUpperCase());
	};

	useEffect(() => {
		setLOTONameToLink("");
	}, [searchParams]);

	if (data.id === -1) {
		return (
			<Grid
				container
				style={{
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<input
					style={{
						outline: "none",
						border: "none",
						lineBreak: "auto",
						textAlign: "center",
						width: 148,
						maxWidth: 148,
						marginRight: "10px",
					}}
					value={LOTONameToLink}
					onChange={handleChangeLOTONameChange}
					placeholder={"Enter a name for LOTO"}
					className={classes.input}
					autoComplete="false"
				/>
			</Grid>
		);
	} else return data?.LOTOName;
};
